var _linearGradient, _path, _linearGradient2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_1295a067add08ac066d736fbd8961281a2fdae879e2d1e05aab52a9e66e2d746",
    gradientUnits: "userSpaceOnUse",
    x1: -4326.734,
    y1: -13.591,
    x2: -4325.734,
    y2: -13.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M58.645 86.619L39.344 99.822M58.624 99.445l-19.301 13.203M74.586 101.017l-19.301 13.202"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_1295a067add08ac066d736fbd8961281a2fdae879e2d1e05aab52a9e66e2d746",
    gradientUnits: "userSpaceOnUse",
    x1: 24.851,
    y1: 53.313,
    x2: 110.568,
    y2: 53.313,
    gradientTransform: "matrix(-1 0 0 1 184.492 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_1295a067add08ac066d736fbd8961281a2fdae879e2d1e05aab52a9e66e2d746)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M85.369 73.584l73.022-40.542-83.217 32.244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M74.818 65.641l-28.094-8.653 112.378-24.42-47.417 64.724-26.553-23.708-13.159 18.729z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.c7c118534aae95156068a92eb4088590.svg";
export { ForwardRef as ReactComponent };